import React, { Fragment } from 'react';


class ReportCard extends React.Component {
  render() {
    const { reportName, reportNamePerm } = this.props;
    const reportLabelName = (name) => {
      const alNames = {
        'Deposit': 'Deposits',
        'Purchase': 'Purchases',
        'Account Balance': 'Account Balances',
        'Low balance': 'Low Balances',
        'Monthly Income': 'Monthly Income Report',
        'Monthly Income Cash': 'Monthly Cash Income Report',
        'Consumption & payments Report': 'Daily Reconciliation Report'
      }
      return alNames[name] == undefined ? name : alNames[name]

    }
    return (
      <Fragment>
        <a href={`/schoolAdmin/financialReport/${reportNamePerm}`} className="reportCard text-center btn btn-light" style={{ padding: '10px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
          <div className="form-group" style={{ marginTop: '10px' }}>
            <div className="color-3"><b style={{ marginTop: '5px', marginBottom: '5px' }}>{reportLabelName(reportName)}</b></div>
          </div>
        </a>
      </Fragment>
    );
  }
}

export default ReportCard;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Reports/FinancialReport/reportCard.jsx